import type { ModelConfig } from '@swf/core/store';

import { reducers } from './reducers';
import { selectors } from './selectors';
import type { ActiveTableState } from './types';

export const defaultState = {
  activeTablesCount: 0
} satisfies ActiveTableState;

interface ActiveTableModel extends ModelConfig<ActiveTableState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const activeTable: ActiveTableModel = {
  state: defaultState,
  reducers,
  selectors
};

export default activeTable;
